import api from './api';

export interface TriageItem {
  _id: string;
  conversationId: string;
  waId: string;
  externalUserId?: string;
  metaPageId?: string;
  inboundTimestamp?: string;
  customerName: string;
  isVip: boolean;
  channel: 'whatsapp' | 'web' | 'instagram' | 'facebook';
  rawInboundText: string;
  triageCategory: 'none' | 'recipe_inquiry' | 'discount_negotiation' | 'toxic_deescalation' | 'vip_custom_request' | 'order_intent' | 'general_inquiry';
  triageSeverity: 'low' | 'medium' | 'high' | 'critical';
  aiDraftResponse: string;
  finalOutboundResponse?: string;
  status: 'pending' | 'approved' | 'amended' | 'taken_over' | 'auto_dispatched';
  llmProvider: string;
  llmLatencyMs: number;
  createdAt: string;
  updatedAt: string;
}

export const getTriageQueue = async (limit: number = 50): Promise<TriageItem[]> => {
  const res = await api.get<{ success: boolean; data: TriageItem[] }>(`/chatbot/triage?limit=${limit}`);
  return res.data.data;
};

export const approveTriageDraft = async (id: string): Promise<TriageItem> => {
  const res = await api.post<{ success: boolean; data: TriageItem }>(`/chatbot/triage/${id}/approve`);
  return res.data.data;
};

export const amendTriageDraft = async (id: string, amendedText: string): Promise<TriageItem> => {
  const res = await api.post<{ success: boolean; data: TriageItem }>(`/chatbot/triage/${id}/amend`, { amendedText });
  return res.data.data;
};

export const takeoverTriageDraft = async (id: string): Promise<TriageItem> => {
  const res = await api.post<{ success: boolean; data: TriageItem }>(`/chatbot/triage/${id}/takeover`);
  return res.data.data;
};

export const discardTriageDraft = async (id: string, conversationId?: string): Promise<void> => {
  try {
    const targetId = conversationId || id;
    await api.delete(`/flywheel/conversations/${targetId}/hard`);
  } catch {
    // Fallback to chatbot triage discard endpoint
  }
  await api.post(`/chatbot/triage/${id}/discard`);
};
